import { useState } from 'react'
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import NewPasswordStep from '../components/molecules/auth/NewPasswordStep'
import EmailAuthStep from '../components/molecules/auth/EmailAuthStep'
import { useBack } from '../hooks/useBack'

const ResetPassword = () => {
  const [step, setStep] = useState('email-verification')
  const [emailAuth, setEmailAuth] = useState({ email: '', code: '' })
  const [newPassword, setNewPassword] = useState({ pwd: '', confirm: '' })
  const goBack = useBack(); // 뒤로가기 훅 호출

  return (
    <DefaultLayout
      headerType="sub"
      onBack={goBack}
      title="비밀번호 찾기">
      {step === 'email-verification' && (
        <EmailAuthStep
          mode="reset"
          emailAuth={emailAuth}
          setEmailAuth={setEmailAuth}
          onNext={() => setStep('new-password')}/>
      )}
      {step === 'new-password' && (
        <NewPasswordStep
          email={emailAuth.email}
          newPassword={newPassword}
          setNewPassword={setNewPassword}/>
      )}
    </DefaultLayout>
  )
}

export default ResetPassword
